import { createContext, useContext, useState, type ReactNode } from 'react'

const SourceModeContext = createContext<{ showSources: boolean; toggle: () => void }>({
	showSources: false,
	toggle: () => {},
})

export const useSourceMode = () => useContext(SourceModeContext)

export const SourceModeProvider = ({ children }: { children: ReactNode }) => {
	const [showSources, setShowSources] = useState(false)

	return <SourceModeContext.Provider value={{ showSources, toggle: () => setShowSources(prev => !prev) }}>{children}</SourceModeContext.Provider>
}

export const SourceModeToggle = () => {
	const { showSources, toggle } = useSourceMode()

	return (
		<button
			type="button"
			onClick={toggle}
			className={`mt-6 flex items-center gap-2 text-xs transition-colors ${
				showSources ? 'font-semibold text-brand' : 'text-muted-500 hover:text-muted-700'
			}`}
		>
			<span className={`inline-block h-2 w-2 rounded-full ${showSources ? 'bg-brand' : 'bg-muted-300'}`} />
			{showSources ? 'Sources on' : 'Show sources'}
		</button>
	)
}

export const Source = ({ href, children }: { href: string; children: ReactNode }) => {
	const { showSources } = useSourceMode()

	if (showSources) {
		return (
			<a
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				className="underline decoration-brand/40 decoration-1 underline-offset-2 transition-colors hover:decoration-brand"
			>
				{children}
			</a>
		)
	}

	return <>{children}</>
}
